import {
  Avatar,
  Flex,
  Button,
  Text,
  useColorModeValue,
  Tag,
  TagLabel,
  Box,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getGameById,
  getSkills,
  MaintainGameView,
} from 'utils/game/gameService';
import { DemoPlayRoutePath } from 'config/constant';
import AvatarImg from 'assets/img/avatars/avatar8.png';
import MobileOrientationPrompt from '../components/MobileOrientationPrompt'; // ✅ New import

export default function Settings(props: {
  name: string;
  avatar: string;
  banner: string;
  data?: any;
}) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { name, avatar, banner, data } = props;

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'secondaryGray.800';

  const [skills, setSkills] = useState<any[]>([]);
  const [authorArray, setauthorArray] = useState<any[]>([]);
  const [profile, setProfile] = useState<any>([]);

  const [showPrompt, setShowPrompt] = useState(false); // ✅ new
  const [pendingPlay, setPendingPlay] = useState(false); // ✅ new

  const gameProfile = async (id: any) => {
    const result = await getGameById(id);
    if (result?.status !== 'Success') {
      setProfile([]);
      return console.log('getGameById error: ' + result?.message);
    } else {
      setProfile(result.data);
    }
  };

  const gameSkill = async () => {
    const result = await getSkills();
    if (result?.status !== 'Success') {
      setSkills([]);
      return console.log('getSkills error: ' + result?.message);
    } else {
      setSkills(result.data);
    }
  };

  const playPerview = async () => {
    const isMobile = /iphone|ipod|android|ipad/i.test(
      navigator.userAgent.toLowerCase(),
    );
    const isLandscape = window.innerWidth > window.innerHeight;

    if (isMobile && !isLandscape) {
      setShowPrompt(true);
      setPendingPlay(true);
      return;
    }

    const result = await MaintainGameView(id);
    if (result?.status !== 'Success') {
      return console.log('MaintainGameView error: ' + result?.message);
    }
    navigate(`${DemoPlayRoutePath}${id}`);
  };

  // Retry playPerview if rotated
  useEffect(() => {
    if (pendingPlay && window.innerWidth > window.innerHeight) {
      setShowPrompt(false);
      setPendingPlay(false);
      playPerview();
    }
  }, [pendingPlay]);

  useEffect(() => {
    gameProfile(id);
    gameSkill();
  }, []);

  useEffect(() => {
    if (profile.gameSkills) {
      const Array = profile.gameSkills.split(',');
      setauthorArray(Array);
    }
  }, [profile]);

  const findSkillName = (authorNumber: any) => {
    const matchedSkill = skills.find(
      (option) => option.id === Number(authorNumber),
    );
    return matchedSkill ? matchedSkill.name : null;
  };

  return (
    <Card
      width="100%"
      mb="20px"
      alignItems="center"
      boxShadow="3px 4px 40px 4px rgba(112, 144, 176, 0.11)"
    >
      <Flex
        w="100%"
        bgGradient="linear(to-b, brand.400, brand.600)"
        minH={{ sm: '100px', md: '127px' }}
        borderRadius="16px"
      ></Flex>

      <Avatar
        mx="auto"
        bg="#fff"
        src={AvatarImg}
        h="87px"
        w="87px"
        mt="-43px"
        mb="15px"
      />

      <Box w="100%">
        <Text
          fontSize={{ base: 'xl', lg: '2xl' }}
          textColor={textColorPrimary}
          fontWeight="700"
          textAlign="center"
        >
          {profile.gameTitle}
        </Text>

        <Flex direction="column" mt="15px" mb="10px">
          <Text
            fontSize={{ base: 'md', lg: 'xl' }}
            color={textColorPrimary}
            fontWeight="bold"
          >
            Duration :
          </Text>
          <Text fontSize="md" mb="15px" mt="15px" color={textColorSecondary}>
            {Math.round(profile.gameDuration * 0.6)} mins
          </Text>
        </Flex>

        <Flex direction="column" mb="10px">
          <Text
            fontSize={{ base: 'md', lg: 'xl' }}
            color={textColorPrimary}
            fontWeight="bold"
          >
            Story Line :
          </Text>
          <Text fontSize="md" mb="15px" mt="15px" color={textColorSecondary}>
            {profile.gameStoryLine}
          </Text>
        </Flex>

        <Flex direction="column" mb="10px">
          <Text
            fontSize={{ base: 'md', lg: 'xl' }}
            color={textColorPrimary}
            fontWeight="bold"
          >
            Skills :
          </Text>
          <Text fontSize="md" mb="15px" mt="15px" color={textColorSecondary}>
            {authorArray
              .map((authorItem) => findSkillName(authorItem))
              .filter((skillName) => skillName !== null)
              .map((skillName, index) => (
                <Tag
                  key={index}
                  size="md"
                  variant="solid"
                  colorScheme="brandScheme"
                  m="2"
                >
                  <TagLabel>{skillName}</TagLabel>
                </Tag>
              ))}
          </Text>
        </Flex>

        <Flex direction="column" mb="10px">
          <Text
            fontSize={{ base: 'md', lg: 'xl' }}
            color={textColorPrimary}
            fontWeight="bold"
          >
            Learning Outcomes :
          </Text>
          <Text fontSize="md" mb="15px" mt="15px" color={textColorSecondary}>
            {profile.gameLearningOutcome}
          </Text>
        </Flex>

        <Flex direction="column" mb="10px">
          <Text
            fontSize={{ base: 'md', lg: 'xl' }}
            color={textColorPrimary}
            fontWeight="bold"
          >
            Author :
          </Text>
          <Text fontSize="md" mb="15px" mt="15px" color={textColorSecondary}>
            {profile.gameAuthorName}
          </Text>
        </Flex>
      </Box>

      <Box w="100%" display="flex" justifyContent="center" mb="15px" mt="15px">
        <Box w="80%" display="flex" justifyContent="center">
          <Button
            variant="darkBrand"
            color="white"
            fontSize="sm"
            fontWeight="500"
            borderRadius="70px"
            w={{ sm: '100%', md: '200px' }}
            px="24px"
            py="5px"
            onClick={playPerview}
          >
            See Preview
          </Button>
        </Box>
      </Box>

      {showPrompt && (
        <MobileOrientationPrompt
          onRotate={() => {
            setShowPrompt(false);
            setPendingPlay(false);
            playPerview();
          }}
        />
      )}
    </Card>
  );
}
